import { openRandomPlayLink } from '../../../config/playLinks';

export default function GameOfMonth() {
  const handleOpenPartner = () => {
    openRandomPlayLink();
  };

  return (
    <section className="py-14 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="md:text-3xl text-2xl font-bold text-gray-900 md:mb-8 mb-4">Game of the month</h2>

        <div
          role="button"
          tabIndex={0}
          onClick={handleOpenPartner}
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleOpenPartner()}
          className="bg-white border border-gray-200 rounded-xl p-4 md:p-6 cursor-pointer"
        >
          <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-6 md:gap-8 items-start">
            <div className="rounded-lg overflow-hidden border border-gray-200 bg-[#f8e5eb] max-w-[520px] mx-auto w-full">
              <img
                src="/game-images/sugar-rush-1000.png"
                alt="Sugar Rush 1000"
                className="w-full h-full object-contain"
              />
            </div>

            <div>
              <h3 className="md:text-3xl text-2xl font-extrabold text-gray-900">Sugar Rush 1000</h3>

              <div className="mt-1 flex items-center gap-2">
                <div className="flex text-orange-500 text-lg leading-none">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <span className="text-lg font-semibold text-gray-900">4.9</span>
              </div>

              <p className="mt-4 md:text-lg text-md text-gray-700 leading-relaxed">
                <span className="italic">Sugar Rush 1000</span> by Pragmatic Play is a
                high-volatility, candy-themed cluster-pay slot with tumbling reels and
                multipliers that can reach up to 1,024x, delivering fast and explosive gameplay.
              </p>

              <ul className="mt-5 space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#6b4de6] mt-0.5"></i>
                  <span>98.69% RTP with high volatility for bigger swing potential</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#6b4de6] mt-0.5"></i>
                  <span>
                    Cluster-pay mechanic with tumbling reels and multipliers up to 1,024x
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#6b4de6] mt-0.5"></i>
                  <span>
                    Up to 25,000x max win by chaining candy bombs and bonus features
                  </span>
                </li>
              </ul>

              <div className="mt-6">
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenPartner();
                  }}
                  className="px-7 py-3 bg-gradient-to-b from-orange-500 to-orange-600 text-white font-bold rounded-lg shadow-sm hover:brightness-105 transition-all whitespace-nowrap"
                >
                  Play Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}